// src/components/ProductSection.jsx
import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../styles/ProductSection.scss";
import img1 from "../assets/boiler_vertical.png";
import img2 from "../assets/aquecedor.png";
import Logo from "../assets/logo.png";
const PRODUCTS = [
  {
    title: "Aquecedor a Gás",
    text: `O aquecedor de passagem a gás é um equipamento moderno e eficiente, projetado para fornecer água quente de forma contínua e sob demanda, ideal para banhos e usos domésticos. Funciona com gás GLP (botijão) ou GN (gás natural encanado), dependendo do modelo.

Diferente dos sistemas com reservatório, o aquecedor de passagem aquece a água instantaneamente à medida que ela circula pelo aparelho, garantindo economia de energia e água quente sempre que necessário.`,
    imgSrc: img2,
  },
  {
    title: "Boiler",
    text: `Os boilers são reservatórios térmicos utilizados para armazenar e conservar a água aquecida, garantindo conforto e economia no dia a dia. Perfeitos para sistemas de aquecimento solar, gás ou elétrico, eles mantêm a temperatura da água por longos períodos, proporcionando banhos quentes a qualquer hora.`,
    imgSrc: img1,
  },
];

function ProductItem({ item, reverse }) {
  const elRef = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    obs.observe(elRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <Row
      ref={elRef}
      className={`product-item align-items-center ${reverse ? "reverse" : ""}`}
    >
      <Col md={6} className="image-col">
        <img
          src={item.imgSrc}
          alt={item.title}
          className={`slide-up ${visible ? "visible" : ""}`}
        />
      </Col>
      <Col md={6} className="text-col">
        <h3 className={`pop-in ${visible ? "visible" : ""}`}>{item.title}</h3>
        <p
          className={`pop-in ${visible ? "visible" : ""}`}
          style={{ transitionDelay: "0.2s" }}
        >
          {item.text}
        </p>
        <a
          href="https://wa.me/555391425203"
          target="_blank"
          style={{ color: "inherit" }}
        >
          <Button
            className={`pop-in ${visible ? "visible" : ""}`}
            style={{ transitionDelay: "0.4s" }}
          >
            Entre em contato
          </Button>
        </a>
      </Col>
    </Row>
  );
}

export default function ProductSection() {
  return (
    <section className="product-section py-5">
      <Container>
        <div className="section-header text-center mb-5">
          <img src={Logo} alt="ThermalHydro" />
          <h2>Confira nossos produtos exclusivos!</h2>
        </div>
        {PRODUCTS.map((prod, idx) => (
          <ProductItem key={idx} item={prod} reverse={idx % 2 === 1} />
        ))}
      </Container>
    </section>
  );
}
